// @flow

import * as React from 'react'
import { Input } from '@/components'
import { Images } from '@/constants'
import { classnames } from '@/helpers'
import gStyles from '@/../styles/main.scss'
import styles from './styles.scss'

type DropdownQuantityProps = {|
  name: string,
  ariaLabel: string,
  placeholder: string,
  onChange: (value: number) => void,
  error?: ?string,
  label: string,
  value: ?number | string,
  limit: number, // eslint-disable-line react/require-default-props
  dropdown?: ?React.Node,
  type?: 'number' | 'text',
  disabled?: boolean,
|}

type DropdownQuantityState = {|
  visible: boolean,
  error: string,
|}

export const Quantity = ({
  value,
  label,
  onClick,
  className,
}: {
  label: string,
  value: ?number | string,
  onClick: (e: DOMEvent) => void,
  className?: ?string,
}) => (
  <div className={classnames(styles.options, className)}>
    <div className={gStyles.flexOne}>
      <p>{label}</p>
    </div>
    <div className={gStyles.flexOne} css={{ justifyContent: 'flex-end' }}>
      <div className={styles.optionButtons}>
        <button type="button" onClick={onClick} value="-">
          <img className={styles.accessory} src={Images.minus} alt="minus" />
        </button>
        <p>{value || '0'}</p>
        <button type="button" onClick={onClick} value="+">
          <img className={styles.accessory} src={Images.plus} alt="plus" />
        </button>
      </div>
    </div>
  </div>
)

Quantity.defaultProps = {
  className: null,
}

export class DropdownQuantity extends React.Component<
  DropdownQuantityProps,
  DropdownQuantityState,
> {
  static defaultProps = {
    error: '',
    limit: 100,
    dropdown: null,
    disabled: false,
    type: 'number'
  }

  constructor(props: DropdownQuantityProps) {
    super(props)
    this.state = {
      visible: false,
      error: '',
    }
  }

  onFocus = () => {
    this.setState({ visible: true })
  }

  onBlur = () => {
    this.setState(() => ({ visible: false }))
  }

  onChange = (e: DOMEvent) => {
    e.persist()
    const { onChange } = this.props
    let { value } = this.props
    const { limit } = this.props
    const { value: operator } = e.currentTarget
    value = parseInt(value, 10)
    if (operator === '+' && value < limit) {
      value += 1
    } else if (operator === '-') {
      value = Math.max(value - 1, 0)
    }
    onChange(value)
  }

  typeOnChange = (value: string) => {
    const { onChange, limit, disabled } = this.props
    if (!disabled) {
      onChange(Math.min(parseInt(value, 10), limit))
    }
  }

  handleKeyDown = (event: DOMEvent) => {
    // $FlowFixMe
    if (event.keyCode === 13 || event.keyCode === 9) {
      // Enter
      this.onBlur()
    }
  }

  dropdown = () => {
    const { dropdown, ariaLabel, value, label } = this.props
    return (
      dropdown || (
        <div className={styles.optionsContainer}>
          <Quantity
            ariaLabel={`${ariaLabel}-quantity`}
            onClick={this.onChange}
            value={value}
            label={label}
          />
        </div>
      )
    )
  }

  render() {
    const prps = { ...this.props}
    delete prps.onChange // Delete unused non DOM prop
    delete prps.disabled // This is handled custom
    const { name, label, placeholder, ariaLabel, error, value, ...rest } = prps
    const { visible, error: stateError } = this.state
    return (
      <Input
        placeholder={placeholder}
        name={name}
        onFocus={this.onFocus}
        dropDownVisible={visible}
        dropDown={this.dropdown()}
        visible={visible}
        requestClose={this.onBlur}
        ariaLabel={ariaLabel}
        accessory={Images.triangle}
        error={stateError || error}
        value={value}
        onChange={this.typeOnChange}
        label={label}
        {...rest}
        onKeyDown={this.handleKeyDown}
      />
    )
  }
}

export default DropdownQuantity
